"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAndInitializeRulesEngines = void 0;
const Logger_1 = __importDefault(require("../Logger"));
const utils_1 = require("./utils");
const WorkerTypes_1 = require("./WorkerTypes");
const Common_1 = require("../Common");
const MEMO = {};
function integrate(worker) {
    return {
        on(message, callback) {
            // eslint-disable-next-line no-param-reassign
            worker.onmessage = (ev) => {
                if (ev.data.type !== message) {
                    return;
                }
                callback(ev.data.payload);
            };
        },
        push(data) {
            worker.postMessage(data);
        },
    };
}
function productKeyFrom(analytics) {
    const productLineCode = (0, utils_1.productLineCodeFrom)(analytics);
    const productVersion = (0, utils_1.productVersionFrom)(analytics);
    if (!productLineCode || !productVersion) {
        return null;
    }
    return `${productLineCode}.${productVersion}`;
}
function loadAndInitializeRulesEngines(analytics, messageService) {
    return __awaiter(this, void 0, void 0, function* () {
        const oxygenId = (0, utils_1.oxygenIdFrom)(analytics);
        const product = productKeyFrom(analytics);
        if (!oxygenId || !product)
            return [];
        // Memoize so that multiple instances with the same product will access the same worker
        if (!(product in MEMO)) {
            const { facets } = analytics.contextService.context;
            try {
                const ruleEngines = yield messageService.getRulesEngines();
                MEMO[product] = Object.values(ruleEngines).map((engine) => {
                    var _a, _b, _c;
                    const rulesEngineWorker = integrate(new Worker(Common_1.IPM_SOURCE));
                    const { artifact, rules, name, version } = engine;
                    const message = {
                        type: WorkerTypes_1.IpmToWorkerEventType.INIT,
                        payload: {
                            debug: {
                                engine: name,
                                engineVersion: version,
                                product,
                            },
                            logs: analytics.contextService.context.config.debug,
                            context: {
                                user: oxygenId,
                                runtime: {
                                    online: ((_a = facets.browser) === null || _a === void 0 ? void 0 : _a.online) || true,
                                    os: ((_b = facets.device) === null || _b === void 0 ? void 0 : _b.os_name) || "",
                                    osVersion: ((_c = facets.device) === null || _c === void 0 ? void 0 : _c.os_version) || "",
                                },
                            },
                            engine: artifact,
                            rules,
                        },
                    };
                    rulesEngineWorker.push(message);
                    return rulesEngineWorker;
                });
            }
            catch (error) {
                Logger_1.default.error("unable to load rules engine(s)", error);
            }
        }
        return MEMO[product] || [];
    });
}
exports.loadAndInitializeRulesEngines = loadAndInitializeRulesEngines;
